import { useAppContext } from '../../AppContext';
import { SimpleCell, Switch } from '@vkontakte/vkui';
import { Panels } from '../Consts';

export const AllowNotificationsComponent = ({checked, callback}) => {
  const context = useAppContext();

  return (<SimpleCell
    Component="label"
    after={<Switch
      checked={checked}
      onChange={(e) => callback(e)}
    />}
  >
    {context.lang().getKey(Panels.PROFILE_PANEL, 'notify_enable_label')}
  </SimpleCell>)
}